import {BrowserRouter as Router, Route, Routes, Navigate} from "react-router-dom";
import {AuthProvider} from "base/auth";

import {MainAboutPage} from "../container/MainAboutPage";
import {MainApp} from "../../common/container/MainApp";
import {MapViewerModule} from "app/mapviewer/module/MapViewerModule";
import {mapViewerRoutes} from "app/mapviewer/module/MapViewerRoutes";
import {SocioeconomicModule} from "app/countries/module/SocioeconomicModule";
import indicatorsRoutes from "app/countries/module/SocioeconimicRoutes";

export function MainRoutes() {
    return (
        <Router>
            <AuthProvider>
                <Routes>
                    <Route path="" element={<MainApp />}>
                        <Route
                            path="*"
                            element={<Navigate to="/viewer" replace={true} />}
                        />
                        <Route
                            path="/"
                            element={<Navigate to="/viewer" replace={true} />}
                        />
                        <Route path="remap" element={<MainAboutPage />} />

                        <Route path="viewer" element={<MapViewerModule />}>
                            {mapViewerRoutes}
                        </Route>
                        <Route path="indicators" element={<SocioeconomicModule />}>
                            {indicatorsRoutes}
                        </Route>
                    </Route>
                </Routes>
            </AuthProvider>
        </Router>
    );
}
